import React from "react";
import { ConfirmActionModal } from "../../components";
import { DotLoader } from "react-spinners";
import { toast } from "react-toastify";

import qs from "query-string";
import $ from "jquery";

import { range } from "lodash";
import selectors from "./selectors";
import actions from "../../actions";
import PropTypes from "prop-types";
import cn from "classnames";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { paths } from "../../../../../common/constants";
import Moment from "react-moment";

class Posts extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sortTypes: {
        name: true,
        createdAt: false,
        creator: true,
        status: true,
      },
      activeFilter: "createdAt",
      showArchived: false,
      postToSuspend: null,
      postToDelete: null,
      keyword: "",
      start_at: "",
      total: 0,
      limit: 10,
      pageNumber: 1,
      posts: [],
    };

    this.handleGetPosts = this.handleGetPosts.bind(this);
    this.toggleSortTypesState = this.toggleSortTypesState.bind(this);
    this.handleDeletePost = this.handleDeletePost.bind(this);
    this.handleSuspendPost = this.handleSuspendPost.bind(this);
    this.handlePagination = this.handlePagination.bind(this);
    this.handleChangeLimit = this.handleChangeLimit.bind(this);
    this.handleGetUser = this.handleGetUser.bind(this);
    this.handleInputEnter = this.handleInputEnter.bind(this);

    this.suspendPostModalId = "suspendPostModal";
    this.deletePostModalId = "deletePostModal";
  }

  componentDidMount() {
    const {
      getPosts,
      location: { search },
    } = this.props;

    getPosts({...qs.parse(search), post_type: "all", deleted: "true"})
      .then(({ result: { data } }) => {
        const posts = data.data;
        const { total, start_at, limit } = data;
        this.setState({ posts, total, start_at, limit });
      })
      .catch(() => {
        toast.error("Internal Server Error");
      });
  }

  toggleSortTypesState(sortType) {
    const { sortTypes } = this.state;
    this.setState({
      sortTypes: {
        ...sortTypes,
        [sortType]: !sortTypes[sortType],
      },
      activeFilter: sortType,
    });
  }

  redirectToPost(post) {
    const {
      history: { push },
    } = this.props;
    push(paths.build(paths.client.ADMIN_POST_DETAIL, post._id));
  }

  openModal(modalToShow, post) {
    if (modalToShow === this.deletePostModalId) {
      this.setState({ postToDelete: post }, () => {
        $(`#${modalToShow}`).modal("show");
      });
    }
    if (modalToShow === this.suspendPostModalId) {
      this.setState({ postToSuspend: post }, () => {
        $(`#${modalToShow}`).modal("show");
      });
    }
  }

  handleDeletePost() {
    const { deletePost } = this.props;
    const { posts, postToDelete } = this.state;

    deletePost(postToDelete._id)
      .then(({ result: { data } }) => {
        this.setState({
          posts: posts.filter((el) => el._id !== postToDelete._id),
        });
        toast.success("Post was removed successfully");
      })
      .catch(({ response: { data } }) => toast.error(data.message));
  }

  handleSuspendPost() {}

  handlePagination(query, pageNumber) {
    const { getPosts } = this.props;

    getPosts({...query, post_type: "all", deleted: "true"})
      .then(({ result: { data } }) => {
        const posts = data.data;
        const { total, start_at, limit } = data;
        this.setState({ posts, total, start_at, limit, pageNumber });
      })
      .catch(() => {
        toast.error("Internal Server Error");
      });
  }

  handleReloadPosts() {
    const {
      getPosts,
      location: { search },
    } = this.props;

    getPosts({...qs.parse(search), post_type: "all"})
      .then(({ result: { data } }) => {
        const posts = data.data;
        const { total, start_at, limit } = data;
        this.setState({ posts, total, start_at, limit });
      })
      .catch(() => {
        toast.error("Internal Server Error");
      });
  }

  handleGetPosts({ target: { value } }) {
    this.setState({
      keyword: value,
    });
  }

  handleInputEnter(e) {
    if (e.key === "Enter") {
      const { getPosts } = this.props;
      const { limit, keyword } = this.state;

      getPosts({ keyword, start_at: 0, limit: limit, deleted: "true", post_type: "all" })
        .then(({ result: { data } }) => {
          const posts = data.data;
          const { total, start_at, limit } = data;
          this.setState({ posts, total, start_at, limit });
        })
        .catch(() => {
          toast.error("Internal Server Error");
        });
    }
  }

  handleChangeLimit({ target: { value } }) {
    const { getPosts } = this.props;
    // const { limit } = this.state;

    // this.setState({
    //   limit: value,
    // });

    getPosts({
      keyword: this.keyword,
      start_at: this.start_at,
      limit: value,
      deleted: "true",
      type: "all",
    })
      .then(({ result: { data } }) => {
        const posts = data.data;
        const { total, start_at } = data;

        this.setState({ posts, total, start_at, limit: value });
      })
      .catch(() => {
        toast.error("Internal Server Error");
      });
  }

  handleGetUser(userid) {
    const {
      history: { push },
    } = this.props;
    push(paths.build(paths.client.ADMIN_CUSTOMER_DETAIL, userid));
  }

  handlePinPost(post, is_pinned) {
    const { updatePost } = this.props;
    const { posts } = this.state;
    updatePost(post._id, { is_pinned, is_pinned })
      .then(({ result: { data } }) => {
        const newPosts = posts.map((value) =>
          value._id === post._id ? { ...value, is_pinned } : value
        );
        this.setState({
          posts: newPosts,
        });
        toast.success(`${is_pinned ? `Pin` : `Unpin`} post successfully`);
      })
      .catch(({ response: { data } }) => toast.error(data.message));
  }

  render() {
    const isPostItemsLoaded = this.props;
    const {
      posts,
      limit,
      start_at,
      total,
      sortTypes,
      activeFilter,
      postToDelete,
      postToSuspend,
      keyword,
      pageNumber,
    } = this.state;

    const TableContent = () => {
      return posts
        ? posts.map((item, key) => (
            <tr key={key}>
              <td>{key + 1}</td>
              <td>{item._id}</td>
              <td>{item.title}</td>
              <td>{item.customerInfo.email}</td>
              <td>{item.price}</td>
              <td>{item.type}</td>
              <td>
                <Moment format="YYYY/MM/DD hh:mm">{item.createdAt}</Moment>
              </td>
              <td>
                <i
                  className="fa fa-thumb-tack table-action-but"
                  style={{
                    color:
                      typeof item.is_pinned !== "undefined"
                        ? item.is_pinned
                          ? `darkgray`
                          : `initial`
                        : `initial`,
                  }}
                  onClick={() =>
                    this.handlePinPost(
                      item,
                      typeof item.is_pinned !== "undefined"
                        ? !item.is_pinned
                        : true
                    )
                  }
                >
                  <span className="tooltiptext">
                    {typeof item.is_pinned !== "undefined"
                      ? item.is_pinned
                        ? `Unpin`
                        : `Pin`
                      : `Pin`}{" "}
                    post
                  </span>{" "}
                </i>
                <i
                  className="fa fa-pencil table-action-but"
                  onClick={() => this.redirectToPost(item)}
                >
                  {" "}
                  <span className="tooltiptext">Edit post</span>{" "}
                </i>
                <i
                  className="fa fa-lock table-action-but"
                  onClick={() => this.openModal(this.suspendPostModalId, item)}
                >
                  {" "}
                  <span className="tooltiptext">Suspend post</span>{" "}
                </i>
                <i
                  className="fa fa-trash table-action-but"
                  onClick={() => this.openModal(this.deletePostModalId, item)}
                >
                  {" "}
                  <span className="tooltiptext">Delete post</span>{" "}
                </i>
                <i
                  className="fa fa-user table-action-but"
                  onClick={() => this.handleGetUser(item.customer_id)}
                >
                  {" "}
                  <span className="tooltiptext">User info</span>{" "}
                </i>
              </td>
            </tr>
          ))
        : null;
    };

    const TablePagination = (props) => {
      const { total, limit, start_at, onPagination } = props;
      const numberOfPages = Math.ceil(total / limit) || 1; // cannot get total so so replaced number of pages with Next button

      // if (numberOfPages === 1) {

      //   return null;
      // }

      const paginationContent = range(1, numberOfPages + 1).map(
        (pageNumber) => {
          const active = pageNumber * limit === start_at - 1;
          return (
            <div key={pageNumber} className={cn("page-item", { active })}>
              <button
                className="page-link"
                onClick={() => {
                  onPagination(
                    {
                      start_at: start_at, //(pageNumber - 1) * limit + 1,
                      limit: limit,
                      keyword: keyword.length > 0 ? keyword : null,
                      deleted: "true",
                    },
                    pageNumber
                  );
                }}
              >
                Next
              </button>
            </div>
          );
        }
      );

      return (
        <div className="d-flex `table-pagination` float-right">
          {paginationContent}
        </div>
      );
    };

    const deletePostModal = postToDelete ? (
      <ConfirmActionModal
        id={this.deletePostModalId}
        itemBeingDeleted={postToDelete}
        onConfirm={this.handleDeletePost}
        text={`Are you sure you want to delete ${postToDelete.title}`}
        title="Delete"
        isDeleteModal
      />
    ) : null;

    const suspendPostModal = postToSuspend ? (
      <ConfirmActionModal
        id={this.suspendPostModalId}
        itemBeingDeleted={postToSuspend}
        onConfirm={this.handleSuspendPost}
        text={`Are you sure you want to suspend ${postToSuspend.title}`}
        title="Suspend"
        isDeleteModal
      />
    ) : null;

    const content = (
      <section>
        {deletePostModal}
        {suspendPostModal}
        <div className="row mb-4">
          <div className="col-sm-12 col-md-6 col-align-left">
            <div className="align-vertical">
              <label>Show entries</label>
              <select
                className="custom-select custom-select-sm form-control form-control-sm"
                onChange={this.handleChangeLimit}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="All">All</option>
              </select>
            </div>
          </div>
          <div className="col-sm-12 col-md-6 col-align-right">
            <div className="align-vertical">
              <label>Search Title</label>
              <input
                type="search"
                className="form-control form-control-sm search-input-box"
                placeholder="Type and enter to search"
                value={keyword}
                onChange={this.handleGetPosts}
                onKeyDown={this.handleInputEnter}
              ></input>
            </div>
          </div>
        </div>
        <div className="row mb-4">
          <div className="col">
            <div id="posts">
              <table
                className="table table-striped table-bordered table-sm"
                cellSpacing="0"
                width="100%"
              >
                <thead>
                  <tr>
                    <th className="th-sm">
                      <div className="d-flex">
                        <div className="th-title">No</div>
                        <i
                          className={cn("fa ml-2 fa-caret-up", {
                            isActive:
                              sortTypes[activeFilter] && activeFilter === "no",
                          })}
                        />
                        <i
                          className={cn("fa ml-2 fa-caret-down", {
                            isActive:
                              !sortTypes[activeFilter] && activeFilter === "no",
                          })}
                        />
                      </div>
                    </th>
                    <th className="th-sm">
                      <div className="d-flex">
                        <div className="th-title">Post ID</div>
                        <i
                          className={cn("fa ml-2 fa-caret-up", {
                            isActive:
                              sortTypes[activeFilter] &&
                              activeFilter === "name",
                          })}
                        />
                        <i
                          className={cn("fa ml-2 fa-caret-down", {
                            isActive:
                              !sortTypes[activeFilter] &&
                              activeFilter === "name",
                          })}
                        />
                      </div>
                    </th>
                    <th className="th-sm">
                      <div className="d-flex">
                        <div className="th-title">Title</div>
                        <i
                          className={cn("fa ml-2 fa-caret-up", {
                            isActive:
                              sortTypes[activeFilter] &&
                              activeFilter === "name",
                          })}
                        />
                        <i
                          className={cn("fa ml-2 fa-caret-down", {
                            isActive:
                              !sortTypes[activeFilter] &&
                              activeFilter === "name",
                          })}
                        />
                      </div>
                    </th>
                    <th className="th-sm">
                      <div className="d-flex">
                        <div className="th-title">Email</div>
                        <i
                          className={cn("fa ml-2 fa-caret-up", {
                            isActive:
                              sortTypes[activeFilter] &&
                              activeFilter === "posts_count",
                          })}
                        />
                        <i
                          className={cn("fa ml-2 fa-caret-down", {
                            isActive:
                              !sortTypes[activeFilter] &&
                              activeFilter === "posts_count",
                          })}
                        />
                      </div>
                    </th>
                    <th className="th-sm">
                      <div className="d-flex">
                        <div className="th-title">Price</div>
                        <i
                          className={cn("fa ml-2 fa-caret-up", {
                            isActive:
                              sortTypes[activeFilter] &&
                              activeFilter === "trips_count",
                          })}
                        />
                        <i
                          className={cn("fa ml-2 fa-caret-down", {
                            isActive:
                              !sortTypes[activeFilter] &&
                              activeFilter === "trips_count",
                          })}
                        />
                      </div>
                    </th>
                    <th className="th-sm">
                      <div className="d-flex">
                        <div className="th-title">Type</div>
                      </div>
                    </th>
                    <th className="th-sm">
                      <div className="d-flex">
                        <div className="th-title">Date</div>
                        <i
                          className={cn("fa ml-2 fa-caret-up", {
                            isActive:
                              sortTypes[activeFilter] &&
                              activeFilter === "created_date",
                          })}
                        />
                        <i
                          className={cn("fa ml-2 fa-caret-down", {
                            isActive:
                              !sortTypes[activeFilter] &&
                              activeFilter === "created_date",
                          })}
                        />
                      </div>
                    </th>
                    <th className="th-sm">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <TableContent />
                </tbody>
              </table>

              <TablePagination
                total={total}
                limit={limit}
                start_at={start_at}
                onPagination={this.handlePagination}
              />
              {!isPostItemsLoaded ? (
                <div className="spinner-container">
                  <DotLoader sizeUnit={"px"} size={50} color={"#00DD8C"} />
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </section>
    );

    return (
      <React.Fragment>
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">{content}</div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

Posts.defaultProps = {};

Posts.propTypes = {
  isPostItemsLoaded: PropTypes.bool.isRequired,
  getPosts: PropTypes.func.isRequired,
  deletePost: PropTypes.func.isRequired,
  getCustomerDetail: PropTypes.func.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
};

export default connect(selectors, {
  ...actions.posts,
})(withRouter(Posts));



// WEBPACK FOOTER //
// ./client/react/Admin/views/Posts/index.jsx